import InvoiceStatus from '../../types/invoice/InvoiceStatus';

export const paymentStatus = (invoiceStatus: string, canceled: boolean) => {
    return canceled &&
        invoiceStatus !== InvoiceStatus.FullyPaid &&
        invoiceStatus !== InvoiceStatus.PartiallyPaid
        ? InvoiceStatus.Canceled
        : invoiceStatus;
};
